import { Injectable } from "@angular/core";

import { CommonState } from "../state";

import { TermsAndConditionsVersion } from "./terms-and-conditions.model";

@Injectable({
	providedIn: "root",
})
export class TermsAndConditionsSelector {
	getHistory() {
		return (state: CommonState): TermsAndConditionsVersion[] | undefined =>
			state.termsAndConditions?.history?.sort((a, b) => {
				const dateA = Date.parse(a.effectiveFrom!);
				const dateB = Date.parse(b.effectiveFrom!);
				return dateB - dateA;
			});
	}

	getLatestVersion() {
		return (state: CommonState): TermsAndConditionsVersion | undefined => state.termsAndConditions?.latestVersion;
	}
}
